---
title: Fishing Techniques
description: A starter hub for fishing techniques and condition-based learning in Roddo.
---

# Fishing Techniques

Technique gets easier to improve when you pair what you tried with what the conditions were doing.

Use Roddo to log the details that matter: gear, presentation, depth, location context, weather, water clarity, and the time of day.

## Start here

- [Beginner fishing tips](/learn/beginner-fishing-tips)
- [Catch log guide](/learn/catch-log)
- [FishIQ guide](/learn/fishiq)
